import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { resourceReducer } from './+state/resource.reducer';
import { EffectsModule } from '@ngrx/effects';
import { HttpClientModule } from '@angular/common/http';
import { DefaultDataServiceConfig, DefaultDataServiceFactory, EntityCollectionReducerMethodsFactory, EntityCollectionServiceFactory, NgrxDataModule } from 'ngrx-data';
import { ChassisDataServiceFactory } from './services/chassis-data.service';
import { ChassisEntityCollectionServiceFactory } from './services/chassis-entity-collection-service-base';
import { ResourceEffects } from './+state/resource.effects';
import { ResourceService } from './services/resource.service';
import { ChassisEntityCollectionReducerMethodsFactory } from './services/chassis-entity-collection-reducer-methods-factory';
import { ChassisEntityDispatcherFactory } from './services/chassis-entity-dispatcher-base';

@NgModule({
    imports: [
        HttpClientModule,
        NgrxDataModule.forRoot({}),
        StoreModule.forFeature('resources', resourceReducer),
        EffectsModule.forFeature([
            ResourceEffects
        ]),
    ],
    exports: [],
    declarations: [],
    entryComponents: [],
    providers: [
        {
            provide: DefaultDataServiceConfig,
            useFactory: (environment: any): DefaultDataServiceConfig => {
                return {
                    root: environment.resource_api_url,
                    timeout: 10000
                };
            },
            deps: ['ENVIRONMENT']
        },
        {
            provide: DefaultDataServiceFactory,
            useClass: ChassisDataServiceFactory
        },
        {
            provide: EntityCollectionReducerMethodsFactory,
            useClass: ChassisEntityCollectionReducerMethodsFactory
        },
        {
            provide: EntityCollectionServiceFactory,
            useClass: ChassisEntityCollectionServiceFactory
        },
        ChassisEntityCollectionServiceFactory,
        ResourceService,
        ChassisEntityCollectionServiceFactory,
        ChassisEntityDispatcherFactory
        // ChassisDataService
        /*ResourceEffects*/
    ],
})
export class ChassisResourceModule {

}



// WEBPACK FOOTER //
// ./libs/chassis-resource/src/chassis-resource.module.ts